module.exports = __webpack_public_path__ + "img/bradesco.82ce08cf.svg";